import { pdfCommissions, pdfTraining1 } from '@/config'

const referralLink = 'https://aal4.adj.st/?adjust_t=v9yo7k0_76x32g3&adjust_campaign=app-test&adjust_deeplink=jumia%3A%2F%2Fma%2F&adjust_redirect=https%3A%2F%2Fwww.jumia.ma%2F%3Futm_source%3Djforce%26utm_medium%3Dreferral'

const dashboardGetUpdatedItems = [
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      key: 'dashboard.media.facebook_group'
    },
    link: 'https://www.facebook.com/groups/2187725794651776/',
    newPage: true
  },
  {
    img: 'img/dashboard/youtube.svg',
    title: {
      key: 'dashboard.media.youtube'
    },
    link: 'https://www.youtube.com/channel/UCVQ7EHd-9JSkKiUI5Zr0kzQ',
    newPage: true
  },
  {
    img: 'img/dashboard/magik.png',
    title: {
      key: 'dashboard.other.magic_page'
    },
    link: 'https://www.jumia.ma/jforcedeals/',
    newPage: true
  }
]

const dashboardContactTheTeamItems = [
  {
    img: 'img/dashboard/contact-form.svg',
    title: {
      key: 'dashboard.contact.reclamation'
    },
    link: 'https://docs.google.com/forms/d/1Kvpr6t_enY_eXClaxEF4_iuT8swPr6SmglYffXCtHLg/edit',
    newPage: true
  },
  {
    img: 'img/dashboard/whatsapp.svg',
    title: {
      key: 'dashboard.contact.whatsapp'
    },
    subtitle: {
      text: '06 69 28 12 63',
      isKey: false
    },
    link: 'https://wa.me/+212669281263',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      key: 'dashboard.join.facebook_page'
    },
    link: 'https://web.facebook.com/LaJforceMaroc',
    newPage: true
  }
]

const dashboardOtherItems = [
  {
    img: 'img/dashboard/faqs.svg',
    title: {
      key: 'dashboard.other.faq'
    },
    newPage: false,
    internalResource: true,
    link: 'jforce_faqs'
  },
  {
    img: 'img/dashboard/agreement.svg',
    title: {
      key: 'dashboard.other.agreement'
    },
    newPage: false,
    internalResource: true,
    link: ''
  },
  {
    img: 'img/dashboard/commissionGrid.svg',
    title: {
      key: 'dashboard.other.commission_grid'
    },
    link: pdfCommissions,
    newPage: true
  },
  {
    img: 'img/dashboard/university.svg',
    title: {
      key: 'dashboard.other.jforce_training'
    },
    link: pdfTraining1,
    newPage: true
  },
  {
    img: 'img/dashboard/jumia-pickup-station.png',
    title: {
      key: 'dashboard.other.pickup_station'
    },
    link: 'https://www.jumia.ma/sp-point-relais/',
    newPage: true
  }
]

export {
  referralLink,
  dashboardGetUpdatedItems,
  dashboardContactTheTeamItems,
  dashboardOtherItems
}
